import * as React from "react";
import {CrudPage} from "../crud/CrudPage";
import {observable} from "mobx";
import {CrudForm} from "../crud/CrudForm";
import {CrudList} from "../crud/CrudList";
import {Field} from "../form/Field";
import {Col, Row,Button ,Container} from "reactstrap";
import {Select} from "../form/fields/Select";
import {enumFormatter, getEnumOptions} from "../../utils/helper";
import {enums} from "../../Enums";
import {api} from "../../api";
import {HasPermission} from "../HasPermission";
import {snakeCase} from "lodash";
import { FormStore } from "../../stores/FormStore";
import {IWindow} from "../../index";
import {ToastContainer} from 'react-toastify';
import { toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const IWindow: IWindow = (window as IWindow);

export class PartyCheckListFormData {
     
}

export class PartyCheckListForm extends CrudForm {
    modelName = 'PartyCheckList';
    

    /* getRolePermissions = () => {
        api.partyCheckList.getRole().then((data: any) => {
            this.getRole = data;
        });
    };*/
  
    renderFields() {
        return (
            <>

            </>
        );
    }
}

export class PartyCheckListFilterForm {
    @observable type = 'polling_unit';
    @observable sub_type = null;
 }

export class PartyCheckListList extends CrudList {
    modelName = 'PartyCheckList';
    @observable isDisabled = false;
    @observable isEdits = false;
    formStore: FormStore<any>;
    @observable is_admin = IWindow.initialState.user.is_admin;
    @observable party_check_list = IWindow.initialState.permissions.party_check_list; // .includes["edit"];

    @observable isView = this.is_admin ? false : this.party_check_list.includes("view");
    @observable isEdit = this.is_admin ? true : this.party_check_list.includes("edit");
  

    colums() {
        return [ 
            {
                name:  "title",
                label:     "Title",
            },

            {
                name: "type",
                label: "Type",
                formatter: enumFormatter(enums.checkListType)
            },
            {
                name: "sub_type",
                label: "Sub Type",
                formatter: enumFormatter(enums.checkListSubType)
            },

            {
                name: "is_excluded",
                label: "Status",
                 formatter: (value: any, item: any) => {
                      return (
                        
                        <Container>
                        {  

                              (this.isEdit || this.is_admin ) ?
                                  
                                    value ?
                                      <HasPermission module={snakeCase(this.modelName)} permission="edit">
                                          <Button key={'include-' + item.id} color="polling-unit-status"
                                              disabled={this.isDisabled}
                                              onClick={() => {
                                                  if (!this.isDisabled) {
                                                      this.updateStatus(item);
                                                  }
                                              }}><span
                                          className="badge badge-danger">Excluded</span></Button>
                                        </HasPermission> 
                                        :
                                            <HasPermission module={snakeCase(this.modelName)} permission="edit">
                                                <Button key={'exclude-' + item.id} color="polling-unit-status"
                                                    disabled={this.isDisabled}
                                                    onClick={() => {
                                                        if (!this.isDisabled) {
                                                            this.updateStatus(item);
                                                        }
                                                    }}>
                                                <span
                                                    className="badge badge-success">Included</span></Button>
                                            </HasPermission>
                                : 
                                                                   
                                value ? 
                                    <span
                                      className="badge badge-danger">Excluded</span>
                                :
                                  <span
                                      className="badge badge-success">Included</span>



                            /* this.is_admin ? 
                                value ?
 
                                    <HasPermission module={snakeCase(this.modelName)} permission="edit">
                                        <Button key={'include-' + item.id} color="polling-unit-status"
                                                disabled={this.isDisabled}
                                                onClick={() => {
                                                    if (!this.isDisabled) {
                                                        this.updateStatus(item);
                                                    }
                                                }}><span
                                            className="badge badge-danger">Excluded</span></Button>
                                    </HasPermission> 
                                    :
                                    <HasPermission module={snakeCase(this.modelName)} permission="edit">
                                        <Button key={'exclude-' + item.id} color="polling-unit-status"
                                            disabled={this.isDisabled}
                                            onClick={() => {
                                                if (!this.isDisabled) {
                                                    this.updateStatus(item);
                                                }
                                            }}>
                                        <span
                                            className="badge badge-success">Included</span></Button>
                                    </HasPermission>
                                :                                
                                value ? 
                                <HasPermission module={snakeCase(this.modelName)} permission="view">
                                      <HasPermission module={snakeCase(this.modelName)} permission="edit">
                                            {this.isEdit = true}
                                        </HasPermission>
                                    <Button key={'include-' + item.id} color="polling-unit-status"
                                            disabled={this.isDisabled}
                                            onClick={() => {
                                                if (this.isEdit) {
                                                    this.updateStatus(item);
                                                }
                                            }}><span
                                        className="badge badge-danger">Excluded</span></Button>
                                </HasPermission> 
                                
                                :
                                <HasPermission module={snakeCase(this.modelName)} permission="view">
                                      <HasPermission module={snakeCase(this.modelName)} permission="edit">
                                            {this.isEdit = true}
                                        </HasPermission>
                                    <Button key={'exclude-' + item.id} color="polling-unit-status"
                                        disabled={this.isDisabled}
                                        onClick={() => {
                                            if (this.isEdit) {
                                                this.updateStatus(item);
                                            }
                                        }}>
                                    <span
                                        className="badge badge-success">Included</span></Button>
                                </HasPermission>
 */
                           }
                         
                           
                        </Container> 
                                        
                       /* <Container>
                             

                                
                                 value ?
                                    <HasPermission module={snakeCase(this.modelName)} permission="edit">
                                        <Button key={'include-' + item.id} color="polling-unit-status"
                                                disabled={this.isDisabled}
                                                onClick={() => {
                                                    if (!this.isDisabled) {
                                                        this.updateStatus(item);
                                                    }
                                                }}><span
                                            className="badge badge-danger">Excluded</span></Button>
                                    </HasPermission>  
                                    <HasPermission module={snakeCase(this.modelName)} permission="view">
                                        <span
                                            className="badge badge-danger">Excluded</span>
                                    </HasPermission> 
                                    :
                                    <HasPermission module={snakeCase(this.modelName)} permission="edit">
                                        <Button key={'exclude-' + item.id} color="polling-unit-status"
                                            disabled={this.isDisabled}
                                            onClick={() => {
                                                if (!this.isDisabled) {
                                                    this.updateStatus(item);
                                                }
                                            }}>
                                        <span
                                            className="badge badge-success">Included</span></Button>
                                    </HasPermission>
                                    <HasPermission module={snakeCase(this.modelName)} permission="view">
                                        
                                        <span
                                            className="badge badge-success">Included</span>
                                    </HasPermission>
                                    
                                        
                         
                        </Container> */
                        );
                    },
            },


           /* {
                name: "is_excluded",
                label: "Status",
                formatter: (value: any, item: any) => {
                    return (
                        <>
                            {
                                value ?
                                    <Button key={'include-' + item.id} color="polling-unit-status"
                                            disabled={this.isDisabled}
                                            onClick={() => {
                                                if (!this.isDisabled) {
                                                    this.updateStatus(item);
                                                }
                                            }}><span
                                        className="badge badge-danger">Excluded</span></Button>
                                    :
                                    <Button key={'exclude-' + item.id} color="polling-unit-status"
                                            disabled={this.isDisabled}
                                            onClick={() => {
                                                if (!this.isDisabled) {
                                                    this.updateStatus(item);
                                                }
                                            }}>
                                        <span
                                            className="badge badge-success">Included</span></Button>
                            }
                        </>
                    );
                },
            }, */
        ];
    }

    idColumn() {
        return '';
    }

    actions() {
        return {}
    }

    updateStatus(item: any) {
        this.isDisabled = true;
        if (confirm('Are you sure you want to update status?')) {
            api.partyCheckList.postUpdateStatusAction(item.party_check_list_id || '', {
                'is_excluded': !item.is_excluded,
                'check_list_id': item.id
            }).then(() => {
                this.listTableStore.refresh();
                this.isDisabled = false;
                toast.success('Record Updated successfully!');
            })
        } else {
            this.isDisabled = false;
        }
    }

    renderFilters() {
        return (
            <Container>
            <Row className="form-row">
                <Col md={5}>
                    <ToastContainer autoClose={5000} />
                </Col>
            </Row>
            <Row className="form-row">

                <Col md={3}>
                    <Field
                        name="type"
                        placeholder="Select type"
                        component={Select}
                        options={getEnumOptions(enums.checkListType)}
                        store={this.filterFormStore}
                    />
                </Col>
                <Col md={3}>
                    <Field
                        name="sub_type"
                        placeholder="Select sub type"
                        component={Select}
                        options={getEnumOptions(enums.checkListSubType)}
                        store={this.filterFormStore}
                    />
                </Col>
                <Col md={3} className="grid-search">
                    {this.renderSearch()}
                </Col>
            </Row>
            </Container>
        );
    }
}

export class PartyCheckListPage extends CrudPage {
    modelName = 'PartyCheckList';
    actionButton = false;
}



// WEBPACK FOOTER //
// ./resources/js/components/pages/PartyCheckListPage.tsx